export type PlaceAddress = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
};

export const renderPlaceAddress = (
  place?: PlaceAddress,
  options?: string[],
) => {
  if (!place) return "";
  // Default display short address
  let address = [place?.address1, place?.address2].filter(Boolean); // remove null data
  if (options && options.length !== 0) {
    // Custom display
    address = options
      .map((key) => place?.[key as keyof typeof place])
      .filter(Boolean);
  }
  return address.join(", ");
};
